import React from 'react';

import { LayoutComposer } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import StaticPage from '../PageBuilder/StaticPage';

import HaulLanding from './HaulLanding/HaulLanding';
import css from './LandingPage.module.css';

// Code-owned landing page (no Console CMS dependency). Meta is hardcoded here so
// the homepage — content and SEO — lives entirely in the repo. See memory:
// code-ownership-moat.
const SCHEMA = {
  '@context': 'http://schema.org',
  '@type': 'WebPage',
  description: 'On-demand junk removal — verified, insured haulers compete and you pick the price.',
  name: 'Haul.Taxi',
};

export const LandingPageComponent = () => {
  const layoutAreas = `
    topbar
    main
    footer
  `;
  return (
    <StaticPage
      title="Haul.Taxi — Junk gone. Haulers compete, you pick the price."
      description="Snap a photo of what needs to go. Verified, insured haulers compete for the job — you pick the best price and the pro. On-demand junk removal, your price."
      schema={SCHEMA}
    >
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {layoutProps => {
          const { Topbar, Main, Footer } = layoutProps;
          return (
            <>
              <Topbar as="header" className={css.topbar}>
                <TopbarContainer currentPage="LandingPage" />
              </Topbar>
              <Main as="main" id="main-content" className={css.main}>
                <HaulLanding />
              </Main>
              <Footer>
                <FooterContainer />
              </Footer>
            </>
          );
        }}
      </LayoutComposer>
    </StaticPage>
  );
};

export default LandingPageComponent;
